module.exports = __webpack_public_path__ + "static/white-tee-f8242ba9b6c73bb0388e4f0e874d29d5.png";